import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import React from "react";
import { createRoot } from "react-dom/client";
import { extendedApiSlice } from "./lib/cvsSlice";
import { store } from "./api/store";

store.dispatch(extendedApiSlice.endpoints.getCandidateCvs.initiate());

// New React 18 rendering method
const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);